export class ServiceBookItemDeleteRequest {
   Id: string;
}